var _rect, _path, _path2, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaymentLinks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.8,
    y: 0.8,
    width: 34.4,
    height: 34.4,
    rx: 5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8191 30.3527C21.095 30.3527 23.2777 29.4312 24.887 27.791C26.4963 26.1507 27.4004 23.9261 27.4004 21.6064C27.4004 19.2867 26.4963 17.0621 24.887 15.4218C23.2777 13.7816 21.095 12.8601 18.8191 12.8601L18.8191 21.6064L18.8191 30.3527Z",
    fill: "#857BF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1809 5.63901C14.905 5.63901 12.7223 6.56049 11.113 8.20074C9.50371 9.84098 8.59961 12.0656 8.59961 14.3853C8.59961 16.705 9.5037 18.9296 11.113 20.5699C12.7223 22.2101 14.905 23.1316 17.1809 23.1316L17.1809 14.3853L17.1809 5.63901Z",
    fill: "#857BF9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.8,
    y: 0.8,
    width: 34.4,
    height: 34.4,
    rx: 5,
    stroke: "#B7B7B7",
    strokeWidth: 0.4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentLinks);
export default __webpack_public_path__ + "static/media/PaymentLinks.107c07d1a72f90be8060329a88aacfa1.svg";
export { ForwardRef as ReactComponent };